
<div class="modal-header">
    <h4 class="modal-title">SNOMED CT Browser</h4>
    <button type="button" class="close" aria-label="Close" (click)="passSelectedConcept(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>


<div class="modal-body">
  <div *ngIf="snoMedBeforeChecked && isEnableJSKHealthCare">
      <div class="row">
        <!-- Semantic Tags -->
        <div class="col-xl-3">
          <div class="filter-box">
            <label class="fw-bold d-block mb-2">Filter results by Semantic Tag</label>
            <div *ngFor="let tag of semanticTags" class="d-flex align-items-center mb-2">
              <input type="checkbox" class="me-2" [checked]="tag.isChecked" (change)="onSemanticTagChange(tag, $event)">
              <span class="me-auto">{{ tag.name }}</span>
              <span class="badge bg-secondary">{{ tag.count }}</span>
            </div>
          </div>
        </div>

        <!-- Table & Pagination -->
        <div class="col-xl-9">
          <div class="d-flex mb-2 align-items-center justify-content-between">
            <input type="text" class="form-control form-control-sm w-50" placeholder="Type at least 3 characters"
              [(ngModel)]="srchChiefComplts" [ngModelOptions]="{standalone: true}" (keyup)="snomedCTLst()">

            <div class="d-flex align-items-center">
              <label class="me-2 mb-0">Rows : </label>
              <select class="form-select form-select-sm" [(ngModel)]="pageSize" [ngModelOptions]="{standalone: true}" (change)="onPageSizeChange()">
                <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
              </select>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped table-sm">
              <thead class="table-light">
                <tr>
                  <th>Sl.No</th>
                  <th style="width:200px; white-space:initial;">Name</th>
                  <th>Description</th>
                  <th>CT Code</th>
                </tr>
              </thead>
              <tbody *ngIf="pagedSnomedList.length">
                <tr *ngFor="let g of pagedSnomedList; let i = index">
                  <td>{{ (currentPage-1)*pageSize + i + 1 }}</td>
                  <td>
                    <a href="javascript:void(0)" (click)="onConceptClick(g.concept?.conceptId,g)">
                      {{ g.term }}
                    </a>
                  </td>
                  <td>{{ g.concept?.fsn?.term }}</td>
                  <td>{{ g.concept?.conceptId }}</td>
                </tr>
              </tbody>
              <tbody *ngIf="!pagedSnomedList.length">
                <tr><td colspan="4">No Records Found</td></tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="d-flex justify-between align-center mt-2">
            <button class="btn btn-sm btn-outline-primary me-2" (click)="goToPage(currentPage-1)" [disabled]="currentPage===1">Prev</button>
            <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="btn btn-sm btn-outline-primary ms-2" (click)="goToPage(currentPage+1)" [disabled]="currentPage >= totalPages">Next</button>
          </div>
        </div>
      </div>
   
  </div>

  <div *ngIf="!snoMedBeforeChecked">
     <div class="col-xl-12">
                <div class="table-responsive" >
                  <table datatable  *ngIf="dtRender1"  class="table table-striped table-bordered table-sm" style="width:100%">
                    <thead class="text-center">
  
                     <tr>
                      <th   class="singleLine"> </th>
                      <th   class="singleLine">S.No </th>
                      <th   class="singleLine">Chief Complaint </th>
                      <th   class="singleLine">SNOMED CT CODE </th>
                     
  
                   </tr>
  
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of snoemedList;let i= index;">
                        <td class="singleLine text-center"><input type="checkbox" [(ngModel)]="item.isChkd" (click)="checkedItem(item)"></td>
                        <td class="singleLine text-center">{{i+1}}</td>
                        <td class="singleLine">{{item?.term}}</td>
                        <td class="singleLine">{{item?.conceptId}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
  
               </div>
  </div>


</div>